import { NgModule } from '@angular/core'
import {
  registerFormInputComponent,
  SharedModule,
  registerCustomDetailComponent,
} from '@vendure/admin-ui/core'
import { SelectVariantComponent } from './components/select-variant.component'
import { BundleListPriceInputComponent } from './components/bundle-list-price-input.component'


@NgModule({
  imports: [SharedModule],
  providers: [
    registerCustomDetailComponent({
      locationId: 'product-variant-detail',
      component: SelectVariantComponent,
    }),
    registerFormInputComponent('bundle-list-price-input', BundleListPriceInputComponent),
  ],
})
export class BundleVariantDetailModule {}
